export let PortalTierActionTypes;
(function (PortalTierActionTypes) {
  PortalTierActionTypes["FetchPortalTierInfo"] = "[Portal Tier] Fetched Portal Tier Info";
  PortalTierActionTypes["SetPortalTierInfo"] = "[Portal Tier] Set Portal Tier Info";
})(PortalTierActionTypes || (PortalTierActionTypes = {}));